<div @fade class="container-terms-and-conditions" [ngClass]="{'rapidScore': isRapidScore}">
    <div class="sub-tittle" [ngClass]="{'rapidScore': isRapidScore}" role = "banner">
        <h1 >Test</h1>
        <hr>
    </div>
    <div class="left" >
        <img [src]="!isRapidScore ? './assets/temporals/termsAndConditions_img.svg': './assets/login/loading-rapidScore.png'" alt="">
    </div>
    <div class="right" role = "main">
        <div class="container-form-terms">
            <form class="form-terms" [formGroup]="form" [ngClass]="{'rapidScore': isRapidScore}">
                <div class="input-control-error">
                    <select class="input-search" name="" id="idTest" formControlName="idTest" aria-label="SelectTestCase">
                        <option *ngFor="let t of tests" [value]="t.idTest" aria-label="TestCase">{{t.name}}</option>
                    </select>
                </div>

                <div class="input-control-error">
                    <input id="testDni" placeholder="DNI" class="input-search" type="text" formControlName="document" aria-label="DNI">
                </div>
                <div class="input-control-error">
                    <input id="testName" placeholder="Nombre" class="input-search" type="text" formControlName="name" aria-label="Name">
                </div>
                <div class="input-control-error">
                    <input id="testSurname1" placeholder="Apellido 1" class="input-search" type="text" formControlName="surname1" aria-label="FirstSurname">
                </div>
                <div class="input-control-error">
                    <input id="testSurname2" placeholder="Apellido 2" class="input-search" type="text" formControlName="surname2" aria-label="SecondSurname">
                </div>

            </form>
            <div class="btn-container" *ngIf="!showProgress">
                <button  [ngClass]="{'rapidScore': isRapidScore}" id="testAgreeButton"  class="enable" (click)="onSubmit()" aria-label="ContinueButton">{{ 'TERMS.BUTTONS.CONFIRM' | translate
                    }}</button>
            </div>
            <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="showProgress"
                mode="indeterminate" aria-label="ProgressBar">
            </mat-progress-bar>
        </div>
        <div>
            <p>
                {{getDescription()}}
            </p>
        </div>

    </div>



    <!-- <app-footer *ngIf="+showIcon !== 3" class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer> -->
</div>
